import { render, staticRenderFns } from "./GenerateCertificate.vue?vue&type=template&id=96994398&scoped=true&"
import script from "./GenerateCertificate.vue?vue&type=script&lang=js&"
export * from "./GenerateCertificate.vue?vue&type=script&lang=js&"
import style0 from "./GenerateCertificate.vue?vue&type=style&index=0&id=96994398&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96994398",
  null
  
)

export default component.exports